/* eslint-disable react-hooks/exhaustive-deps */
import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create Menu
export const createMenu = async (menuData) => {
  try {
    const response = await axiosInstance.post(
      API_ROUTES.MENUS.CREATE,
      menuData
    );
    return response.data;
  } catch (error) {
    console.error('Error creating menu:', error);
    throw error;
  }
};

// Update Menu
export const updateMenu = async (menuId, updateData) => {
  try {
    const response = await axiosInstance.put(
      `${API_ROUTES.MENUS.UPDATE}/${menuId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error('Error updating menu:', error);
    throw error;
  }
};

// Get All Menus
export const getMenus = async () => {
  try {
    const response = await axiosInstance.get(
      API_ROUTES.MENUS.GET
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching menus:', error);
    throw error;
  }
};

// Get Single Menu
export const getMenu = async (menuId) => {
  try {
    const response = await axiosInstance.get(
      `${API_ROUTES.MENUS.GET_SINGLE_MENU}/${menuId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching menu:', error);
    throw error;
  }
};

// Delete Menu(s)
export const deleteMenus = async (menuIds) => {
  try {
    const response = await axiosInstance.delete(
      API_ROUTES.MENUS.DELETE,
      {
        data: { ids: menuIds },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting menus:', error);
    throw error;
  }
};

export const getItemList = async () => {
  try {
    const response = await axiosInstance.get(
      API_ROUTES.MENUS.ITEM_LIST
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching menus:', error);
    throw error;
  }
}
